<template>
    <FormSection title="Services Required" :full-height="false" :application-id="referral.application">
        <template #content>
            <section class="row p-2 pb-0">
                <div class="col-12 col-lg-12 px-5 g-0">
                    <div v-if="!isLoading" class="form-group col-12">
                        <div class="row form-check ps-0 mt-2">
                            <div
                                class="col-lg-3 col-md-6 col-sm-12 p-1"
                                v-for="serviceRequired in servicesRequired"
                                :key="serviceRequired.Id"
                            >
                                <div class="border p-1 d-flex align-items-center rounded service-required-wrapper">
                                    <input
                                        type="checkbox"
                                        class="me-3 ms-2 service-required-input"
                                        :id="serviceRequired.Id"
                                        :value="serviceRequired.Value.toFixed()"
                                        v-model="serviceRequiredCollection"
                                        @change="updateServiceRequiredCollection"
                                    />
                                    <label :for="`${serviceRequired.Id}`" class="mb-0">
                                        <span class="me-1 text-capitalize">{{ serviceRequired.Name }}</span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-12 p-1">
                                <div class="border p-1 d-flex rounded flex-column service-required-wrapper">
                                    <div class="d-flex align-items-center service-required-inner-wrapper">
                                        <input
                                            type="checkbox"
                                            class="me-3 ms-2 service-required-input"
                                            id="other"
                                            :value="referral.hasOtherServicesRequired"
                                            v-model="referral.hasOtherServicesRequired"
                                            @change="clearOtherServices"
                                        />
                                        <label for="other" class="mb-0">
                                            <span class="me-1 text-capitalize">Other</span>
                                        </label>
                                    </div>
                                    <template v-if="referral.hasOtherServicesRequired">
                                        <div class="d-flex mt-2 bg-white flex-column p-1">
                                            <label class="mb-1 mt-1 service-required-text-color">Specify </label>
                                            <input
                                                type="text"
                                                class="ms-3 form-control w-90"
                                                v-model="hasOtherServiceRequired"
                                                @input="handleOtherServiceRequired"
                                            />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-12" v-if="isLoading">
                        <div v-for="i of 2" :key="i" class="d-flex mt-4">
                            <span class="shimmer-loading me-2 block-size-2"></span>
                            <span class="shimmer-loading me-2 block-size-2"></span>
                            <span class="shimmer-loading block-size-2"></span>
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./ServicesRequired.ts"></script>
<style src="./ServicesRequired.scss"></style>
